import PropTypes from 'prop-types'

export default function Content({children}) {
  return (
    <div className="modal__content">
      <div className="wrap--row">
        <div className="medium-12 columns">{children}</div>
      </div>
    </div>
  )
}

Content.propTypes = {
  children: PropTypes.node.isRequired,
}
